const SmallDelivery = () => {
	return (
		<svg
			width="16"
			height="17"
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect y="0.78418" width="16" height="16" rx="2.66667" fill="#20AC93" />
			<path
				d="M7.31152 13.9396C7.67743 14.3512 8.32058 14.3512 8.68652 13.9396L12.5068 9.64172C12.866 9.23768 12.5796 8.59894 12.0391 8.59875H10.9326C10.4688 8.59875 10.0928 8.22273 10.0928 7.75891V5.99915C10.0926 5.49137 9.68062 5.07942 9.17285 5.07922H6.82617C6.31825 5.07924 5.90644 5.49126 5.90625 5.99915V7.75891C5.90625 8.22273 5.53022 8.59875 5.06641 8.59875H3.95996C3.41941 8.59875 3.13239 9.2376 3.49121 9.64172L7.31152 13.9396Z"
				fill="#20AC93"
				stroke="white"
				strokeWidth="0.666667"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export default SmallDelivery;
